import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';

const LoadingShell = styled.section`
  min-height: 100vh;
  padding: 120px 2rem 4rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const LoadingTitle = styled.h2`
  font-size: clamp(2rem, 5vw, 3rem);
  margin-bottom: 1.25rem;
  text-align: left;
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isAnalyticsRoute = location.pathname === '/dashboard/analytics';

  if (loading) {
    return (
      <LoadingShell>
        <LoadingTitle>{isAnalyticsRoute ? 'Loading Analytics…' : 'Loading…'}</LoadingTitle>
      </LoadingShell>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
